"use client";

import { useEffect, useState } from "react";
import { debounce } from "throttle-debounce";

const useScroll = () => {
  let scrollPos = 0;
  const [scrollDirection, setScrollDirection] = useState<number>(0);
  const scrollHandler = () => {
    //TODO manage execution on scroll to avoid performance issues
    if (window.scrollY > 0) {
      if (scrollPos > window.scrollY) {
        setScrollDirection(-1);
      } else {
        setScrollDirection(1);
      }
      scrollPos = window.scrollY;
    } else {
      setScrollDirection(0);
    }
  };
  useEffect(() => {
    if (!!typeof window) {
      window.addEventListener("scroll", scrollHandler, { passive: true });
    }
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);
  return scrollDirection;
};

export default useScroll;
